if (!customElements.get('customer-stories')) {
  customElements.define('customer-stories', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.customer-story')];
      this.syncHiddenSlides = () => {
        this.slides.forEach((slide) => {
          const hidden = slide.getAttribute('aria-hidden') === 'true';
          slide.inert = hidden;
          if (hidden) slide.querySelectorAll('video').forEach((video) => video.pause());
        });
      };
      this.observer = new MutationObserver(this.syncHiddenSlides);
      this.slides.forEach((slide) => this.observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] }));
      this.syncHiddenSlides();
      this.pauseVideos = () => this.querySelectorAll('video').forEach((video) => video.pause());
      this.visibilityHandler = () => { if (document.hidden) this.pauseVideos(); };
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.intersection = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) this.pauseVideos();
      });
      this.intersection.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      this.pauseVideos?.();
    }
  });
}
